import "../../styles/templates/_product.scss";
import "../../styles/components/_product-option.scss";
import { createState } from "../helpers/state-subject";
import { getElementOrParentByClassName, showInlineCart } from "../helpers/utils";
import { isMobile } from "../constants/devices.constants";
import { QUICKSHOP_REFRESH, QUICKSHOP_CLOSE } from '../constants/events.constants';
import '../web-components/waitlist-form';
import '../web-components/recommendations-carousel';
import '../web-components/wishlist-button';
import '../web-components/inventory-level';
import '../web-components/product-main-images';
import '../web-components/add-to-cart-overlay';
import '../web-components/product-secondary';
import '../web-components/tooltip-popup';
import '../web-components/size-guide';
import { showModal } from '../services/dialog.service';
import groupBy from '../helpers/groupBy';
import { allOptionsSelected, getRecommendationParameters, matchesCurrentAndSelectedOptions, NO_SELECTED_VARIANT, shownVariant } from "./product-shared";
import { addToCart } from "../services/cart.service";
import { emitShopifyEvent } from "../services/analytics.service";
import { transformStorePhone, toRawPhoneNumber } from "../helpers/transformations";
var CTA_TYPES;
(function (CTA_TYPES) {
    CTA_TYPES["CTA_ADD_CART"] = "addCart";
    CTA_TYPES["CTA_SHOP_SIMILAR"] = "shopSimilar";
    CTA_TYPES["CTA_NOTIFY_ME"] = "notifyMe";
    CTA_TYPES["CTA_NOTIFY_ME_BACK_IN_STOCK_POPUP"] = "notifyMeBackInStockPopup";
})(CTA_TYPES || (CTA_TYPES = {}));
// color "options" are actually different products, so these need to be handled differently
// this will need major adjustments if we ever add multiple color options under one Shopify product
const COLOR_OPTION_NAME = 'color';
var EXPEDITED_OPTIONS_FILTER;
(function (EXPEDITED_OPTIONS_FILTER) {
    EXPEDITED_OPTIONS_FILTER["ALL"] = "all";
    EXPEDITED_OPTIONS_FILTER["EXPEDITED"] = "expedited";
})(EXPEDITED_OPTIONS_FILTER || (EXPEDITED_OPTIONS_FILTER = {}));
class ProductMain extends HTMLElement {
    constructor() {
        super();
    }
    selectedProductIdStore;
    teardownProductMain;
    connectedCallback() {
        console.log("product-main connected");
        const ac = new AbortController();
        const { signal } = ac;
        const selectedVariantStore = createState(undefined);
        this.selectedProductIdStore = createState(window.productId);
        const mode = this.getAttribute("mode");
        const pdpType = this.getAttribute("type");
        const searchParams = new URLSearchParams(window.location.search);
        const skuParam = searchParams.get('sku');
        const variantParam = +searchParams.get('variant');
        let initSelectedVariant = null;
        if (skuParam) {
            initSelectedVariant = allVariants().find((v) => v.sku === skuParam);
        }
        else if (variantParam) {
            initSelectedVariant = allVariants().find((v) => v.variantID === variantParam);
        }
        const initialParamSelections = getInitialSelectionsFromSearchParams(window.location.search);
        const combinedInitialSelections = { ...window.initialDefaultSelections, ...initialParamSelections };
        let initialSelections = window.initialDefaultSelections;
        if (initSelectedVariant) {
            initialSelections = initSelectedVariant.optionsMap;
        }
        else if (getProductVariantsFromOptions(getEffectiveSelections(combinedInitialSelections, this.selectedProductIdStore.get()), this.selectedProductIdStore.get()).length) {
            initialSelections = combinedInitialSelections;
        }
        initialSelections = getEffectiveSelections(initialSelections, this.selectedProductIdStore.get());
        const selectedOptionsStore = createState(initialSelections);
        const expeditedToggleEl = this.querySelector('.product__expedited-options-toggle');
        const expeditedSwitchInput = expeditedToggleEl?.querySelector('.js-expedited-options-switch');
        const showExpeditedOptionsToggle = this.shouldShowExpeditedOptionsToggle(this.selectedProductIdStore.get());
        let expeditedOptionsFilter = EXPEDITED_OPTIONS_FILTER.ALL;
        if (showExpeditedOptionsToggle) {
            expeditedOptionsFilter = expeditedSwitchInput?.checked
                ? EXPEDITED_OPTIONS_FILTER.EXPEDITED
                : EXPEDITED_OPTIONS_FILTER.ALL;
        }
        const activeExpeditedOptionsFilter = () => (showExpeditedOptionsToggle ? expeditedOptionsFilter : EXPEDITED_OPTIONS_FILTER.ALL);
        if (expeditedToggleEl && showExpeditedOptionsToggle) {
            expeditedToggleEl.classList.remove('hidden');
        }
        const onSelectedOptionsChange = (selectedOptions) => {
            if (!selectedOptions) {
                return;
            }
            console.log("selected options", selectedOptions);
            const effectiveSelections = getEffectiveSelections(selectedOptions, this.selectedProductIdStore.get());
            this.updateProductOptionsDisplay(selectedOptions, pdpType);
            this.applyExpeditedOptionsFilter(activeExpeditedOptionsFilter(), effectiveSelections, this.selectedProductIdStore.get());
            if (allOptionsSelected(effectiveSelections)) {
                const selectedVariant = getProductVariantsFromOptions(effectiveSelections, this.selectedProductIdStore.get())[0];
                selectedVariantStore.set(selectedVariant);
            }
            else {
                selectedVariantStore.set(NO_SELECTED_VARIANT);
            }
            removeErrorMessage();
        };
        const onSelectedVariantChange = (variant) => {
            console.log("selected variant", variant);
            if (variant) {
                this.setAttribute("selected-variant", JSON.stringify(variant));
            }
            else {
                this.removeAttribute("selected-variant");
            }
            let ctaTypes;
            const inventoryLevelEl = this.querySelector('inventory-level');
            if (inventoryLevelEl) {
                inventoryLevelEl.setAttribute('level', '');
                inventoryLevelEl.removeAttribute('inventory-quantity');
                inventoryLevelEl.removeAttribute('is-final-sale');
            }
            if (variant) {
                if (variant.available) {
                    ctaTypes = [CTA_TYPES.CTA_ADD_CART];
                }
                else {
                    ctaTypes = [CTA_TYPES.CTA_SHOP_SIMILAR];
                    if (!variant.isFinalSale) {
                        ctaTypes.push(CTA_TYPES.CTA_NOTIFY_ME);
                    }
                }
                if (inventoryLevelEl) {
                    inventoryLevelEl.setAttribute('display', 'show');
                    inventoryLevelEl.setAttribute('inventory-quantity', String(variant.inventoryQuantity));
                    inventoryLevelEl.setAttribute('level', variant.inventoryLevel);
                    if (variant.isFinalSale) {
                        inventoryLevelEl.setAttribute('is-final-sale', 'true');
                    }
                    else {
                        inventoryLevelEl.removeAttribute('is-final-sale');
                    }
                }
            }
            else if (this.getAttribute('is-coming-soon') === 'true') {
                ctaTypes = [CTA_TYPES.CTA_NOTIFY_ME_BACK_IN_STOCK_POPUP];
            }
            else {
                ctaTypes = [CTA_TYPES.CTA_ADD_CART];
                if (inventoryLevelEl) {
                    inventoryLevelEl.setAttribute('display', 'hide');
                }
            }
            const standardShippingOnlyMessageEl = this.querySelector('.product__standard-shipping-only-message');
            if (variant?.standardShippingOnly) {
                standardShippingOnlyMessageEl?.classList.remove('hidden');
            }
            else {
                standardShippingOnlyMessageEl?.classList.add('hidden');
            }
            this.updateProductCtas(ctaTypes);
            if (window.storeAvailability) {
                const collectionAvailabilityMessageEl = this.querySelector('.product__store-availability-message');
                if (collectionAvailabilityMessageEl) {
                    const storeName = collectionAvailabilityMessageEl.dataset.storeName || 'the store';
                    const storePhone = collectionAvailabilityMessageEl.dataset.storePhone || null;
                    const rawStorePhone = toRawPhoneNumber(storePhone) || null;
                    const displayStorePhone = transformStorePhone(storePhone) || null;
                    let message = window.productUi.storeInventory.noVariantSelected;
                    let isLowStock = false;
                    if (variant) {
                        message = window.productUi.storeInventory.productOutOfStock;
                        const variantStoreInventory = window.storeAvailability.atp[variant.sku];
                        if (variantStoreInventory > 0 && variantStoreInventory <= window.productUi.storeInventory.inStoreLowInventoryThreshold) {
                            message = window.productUi.storeInventory.productLowStock;
                            isLowStock = true;
                        }
                        else if (variantStoreInventory > window.productUi.storeInventory.inStoreLowInventoryThreshold) {
                            message = window.productUi.storeInventory.productInStock;
                        }
                    }
                    let availabilityMessage = message.replace('{storeName}', storeName);
                    if (isLowStock) {
                        if (rawStorePhone && displayStorePhone) {
                            const callToConfirmMobile = window.productUi.storeInventory.callToConfirmMobile
                                .replace('{rawPhone}', rawStorePhone);
                            const callToConfirmDesktop = window.productUi.storeInventory.callToConfirmDesktop
                                .replace('{rawPhone}', rawStorePhone)
                                .replace('{displayPhone}', displayStorePhone);
                            availabilityMessage = `${availabilityMessage} `
                                + `<span class="product__store-availability-call-to-confirm product__store-availability-call-to-confirm--mobile">${callToConfirmMobile}</span>`
                                + `<span class="product__store-availability-call-to-confirm product__store-availability-call-to-confirm--desktop">${callToConfirmDesktop}</span>`;
                        }
                        else {
                            availabilityMessage = `${availabilityMessage} ${window.productUi.storeInventory.callToConfirmNoPhone}`;
                        }
                    }
                    const changeStoreLinkEnabled = window.UNTUCKitConfig?.nearbyToggle?.selectMyStoreFunctionalityToggle === true
                        && this.getAttribute('under_store_collection') !== 'true';
                    collectionAvailabilityMessageEl.innerHTML = changeStoreLinkEnabled
                        ? `${availabilityMessage} <a href="/pages/store-locator" class="product__store-availability-change-store-link">Change your store</a>`
                        : availabilityMessage;
                }
            }
        };
        const unsubs = [];
        unsubs.push(selectedOptionsStore.subscribe(onSelectedOptionsChange));
        unsubs.push(selectedVariantStore.subscribe(onSelectedVariantChange));
        if (activeExpeditedOptionsFilter() === EXPEDITED_OPTIONS_FILTER.EXPEDITED) {
            const currentSelections = selectedOptionsStore.get();
            const clearedSelections = this.clearExpeditedFilteredSelections(activeExpeditedOptionsFilter(), currentSelections, this.selectedProductIdStore.get());
            if (clearedSelections !== currentSelections) {
                selectedOptionsStore.set(clearedSelections);
            }
        }
        const generateRecommendationCarousel = () => {
            const el = document.createElement('recommendations-carousel');
            const selectedVariant = selectedVariantStore.get();
            const optionsForRec = selectedVariant.originalOptionsMap ?? selectedVariant.optionsMap;
            const recommendationParameters = getRecommendationParameters({ fit: optionsForRec.fit, size: optionsForRec.size, gender: window.productDepartment, sku: selectedVariant.sku, productId: `${this.selectedProductIdStore.get()}` });
            Object.entries(recommendationParameters).forEach((entry) => {
                const [key, val] = entry;
                el.setAttribute(key, val);
            });
            return el;
        };
        const handleAddToCart = (response) => {
            if (window.UNTUCKitConfig.showAddToCartOverlay) {
                if (response?.items?.length) {
                    const addToCartOverlay = document.createElement('add-to-cart-overlay');
                    addToCartOverlay.setAttribute('cart-line-item-data', JSON.stringify(response.items[0]));
                    const selectedVariant = selectedVariantStore.get();
                    const optionsForRec = selectedVariant.originalOptionsMap ?? selectedVariant.optionsMap;
                    const recommendationParameters = getRecommendationParameters({ fit: optionsForRec.fit, size: optionsForRec.size, gender: window.productDepartment, sku: selectedVariant.sku, productId: `${this.selectedProductIdStore.get()}` });
                    addToCartOverlay.setAttribute('recommendation-parameters', JSON.stringify(recommendationParameters));
                    showModal([addToCartOverlay], { classes: 'add-to-cart-overlay' });
                }
                else {
                    console.error("item added to cart successfully but no data returned");
                }
            }
            else {
                showInlineCart();
            }
            closeQuickshop();
        };
        const closeQuickshop = () => {
            if (mode === 'quickshop') {
                const closeEvent = new CustomEvent(QUICKSHOP_CLOSE);
                window.dispatchEvent(closeEvent);
            }
        };
        this.addEventListener("click", (e) => {
            const target = e.target;
            const productUrl = target.dataset.productUrl;
            if (productUrl && this.selectedProductIdStore.get() !== +target.dataset.productId) {
                if (mode === "quickshop") {
                    const refreshEvent = new CustomEvent(QUICKSHOP_REFRESH, { detail: { handle: target.dataset.productUrl.split("/").slice(-1)[0] } });
                    window.dispatchEvent(refreshEvent);
                }
                else {
                    const urlParams = buildUrlParamsFromSelectedOptions(selectedOptionsStore.get());
                    location.href = `${productUrl}?${urlParams}`;
                }
                return;
            }
            if (target.matches('.js-product-option:not([data-product-url])')) {
                const { optionName, optionValue } = target.dataset;
                const currentSelection = selectedOptionsStore.get();
                const updateValue = isDeselecting(target, currentSelection[optionName], optionValue) ? undefined : optionValue;
                if (updateValue) {
                    emitShopifyEvent("untuckit:product_option_selected", { optionName, optionValue: updateValue });
                }
                selectedOptionsStore.set({ ...selectedOptionsStore.get() || {}, ...{ [optionName]: updateValue } });
                return;
            }
            if (getElementOrParentByClassName(target, 'product__open-size-guide')) {
                const template = document.getElementById("product-size-guide");
                if (template) {
                    const fragment = template.content.cloneNode(true);
                    const sizeGuideEl = fragment.firstElementChild;
                    showModal([sizeGuideEl], { classes: "size-guide" });
                }
                return;
            }
            if (target.classList.contains('js-product-cta')) {
                const action = target.dataset.action;
                switch (action) {
                    case CTA_TYPES.CTA_ADD_CART: {
                        const selectedVariant = selectedVariantStore.get();
                        if (selectedVariant) {
                            if (pdpType === 'bundle') {
                                const itemsToAdd = Object.values(window.bundleVariantGroups).map((variants) => {
                                    const found = variants.find((v) => {
                                        const keys = Object.keys(selectedVariant.optionsMap);
                                        return keys.every((k) => v.optionsMap[k] === selectedVariant.optionsMap[k]);
                                    });
                                    return found;
                                }).map((variant) => {
                                    return {
                                        id: variant.variantID,
                                        quantity: 1
                                    };
                                });
                                addToCart({ items: itemsToAdd }).then((data) => {
                                    console.log("addItemsToCart", data);
                                    showInlineCart();
                                    closeQuickshop();
                                });
                            }
                            else {
                                const properties = {};
                                const recipientEmailEl = document.getElementById('gift-card-recipient-email');
                                if (recipientEmailEl) {
                                    const email = recipientEmailEl.value;
                                    if (recipientEmailEl.checkValidity()) {
                                        properties["Recipient email address"] = email;
                                        properties["_gct-id"] = generateGiftCardId();
                                        removeErrorMessage();
                                    }
                                    else {
                                        const error = email ? 'Please enter a valid email address.' : 'Please enter an email address.';
                                        showErrorMessage(error);
                                        return;
                                    }
                                }
                                addToCart({ items: [{ id: selectedVariant.variantID, quantity: 1, properties }] }).then(handleAddToCart)
                                    .catch((err) => { console.error(err); });
                            }
                        }
                        else {
                            const error = generateErrorFromProductOptions(getEffectiveSelections(selectedOptionsStore.get(), this.selectedProductIdStore.get()));
                            showErrorMessage(error);
                        }
                        break;
                    }
                    case CTA_TYPES.CTA_NOTIFY_ME: {
                        const waitlistFormEl = document.createElement('waitlist-form');
                        const selectedVariant = selectedVariantStore.get();
                        waitlistFormEl.setAttribute('variantId', `${selectedVariant.variantID}`);
                        waitlistFormEl.setAttribute('productId', `${selectedVariant.productId}`);
                        const waitlistTitle = this.getAttribute('is-coming-soon') === 'true' ? window.productUi.waitlist.comingSoon : window.productUi.waitlist.default;
                        waitlistFormEl.setAttribute('title', waitlistTitle);
                        const els = [waitlistFormEl];
                        if (!isMobile()) {
                            els.push(generateRecommendationCarousel());
                        }
                        showModal(els);
                        break;
                    }
                    case CTA_TYPES.CTA_NOTIFY_ME_BACK_IN_STOCK_POPUP: {
                        break;
                    }
                    case CTA_TYPES.CTA_SHOP_SIMILAR: {
                        const recommendationCarousel = generateRecommendationCarousel();
                        showModal([recommendationCarousel]);
                        break;
                    }
                    default:
                        console.error(`unable to determine action for cta click: ${action}`);
                        break;
                }
                return;
            }
            if (getElementOrParentByClassName(target, 'js-back-in-stock-popup')) {
                const selectedVariant = selectedVariantStore.get();
                if (selectedVariant) {
                    window.BIS?.popup?.show({ variantId: selectedVariant.variantID });
                }
                else {
                    window.BIS?.popup?.show();
                }
                return;
            }
            if (getElementOrParentByClassName(target, 'single-tab__button')) {
                emitShopifyEvent('untuckit:product_detail_tab_clicked', { tabName: target.textContent.trim() });
            }
        }, { signal });
        expeditedSwitchInput?.addEventListener('change', () => {
            expeditedOptionsFilter = expeditedSwitchInput.checked
                ? EXPEDITED_OPTIONS_FILTER.EXPEDITED
                : EXPEDITED_OPTIONS_FILTER.ALL;
            const filter = activeExpeditedOptionsFilter();
            this.updateExpeditedToggleDisplay(filter);
            const currentSelections = selectedOptionsStore.get();
            const clearedSelections = this.clearExpeditedFilteredSelections(filter, currentSelections, this.selectedProductIdStore.get());
            if (clearedSelections !== currentSelections) {
                selectedOptionsStore.set(clearedSelections);
            }
            else {
                this.applyExpeditedOptionsFilter(filter, getEffectiveSelections(currentSelections, this.selectedProductIdStore.get()), this.selectedProductIdStore.get());
            }
        }, { signal });
        const fullDetailsLinkEl = this.querySelector('.product__full-details-link');
        if (fullDetailsLinkEl && window.collectionHandle && window.productHandle) {
            fullDetailsLinkEl.href = `/collections/${window.collectionHandle}/products/${window.productHandle}`;
        }
        this.teardownProductMain = () => {
            unsubs.forEach((u) => u());
            ac.abort();
        };
    }
    disconnectedCallback() {
        console.log("product-main disconnected");
        this.teardownProductMain?.();
        this.teardownProductMain = undefined;
    }
    updateProductCtas(ctaTypes) {
        console.log("updating product ctas", ctaTypes);
        const container = this.querySelector('.product__cta-container');
        const ctaTemplate = document.getElementById('product-cta-template');
        if (container && ctaTemplate) {
            container.innerHTML = '';
            const newEls = ctaTypes.map((t, i) => {
                const fragment = ctaTemplate.content.cloneNode(true);
                const el = fragment.firstElementChild;
                el.dataset.action = t;
                el.textContent = getCtaText(t);
                if (i === 0) {
                    el.classList.add('primary');
                }
                else {
                    el.classList.add('secondary');
                }
                if (t === CTA_TYPES.CTA_NOTIFY_ME_BACK_IN_STOCK_POPUP) {
                    el.classList.add('js-back-in-stock-popup');
                }
                return el;
            });
            container.append(...newEls);
        }
    }
    updateProductOptionsDisplay(selectedOptions, type) {
        Object.entries(selectedOptions).forEach((opt) => {
            const [optionType, optionValue] = opt;
            const currentValueEl = this.querySelector(`.product-option__container--${optionType} .product-option__current-value`);
            if (currentValueEl) {
                const optDisplayValue = window.optionHandleToValue[optionValue];
                currentValueEl.textContent = optionValue && optDisplayValue ? `: ${optDisplayValue}` : '';
            }
        });
        this.querySelectorAll('.js-product-option:not(.product-option__value-button--custom)').forEach((el) => {
            el.classList.remove('product-option--selected', 'product-option--out-of-stock', 'product-option--unavailable', 'product-option--expedited-shipping-allowed', 'product-option--expedited-filtered'); // reset style classes
            const { optionName, optionValue, productId } = el.dataset;
            const optionProductId = productId ? +productId : null;
            const isSameValue = selectedOptions[optionName] === optionValue;
            const isSameProduct = optionProductId ? +optionProductId === this.selectedProductIdStore.get() : true;
            const isSelected = optionName === COLOR_OPTION_NAME
                ? isSameProduct
                : isSameValue && isSameProduct;
            if (isSelected) {
                el.classList.add('product-option--selected');
            }
            if (type === "bundle") {
                const associatedVariants = getAssociatedBundleVariants(optionName, optionValue, selectedOptions);
                if (associatedVariants.length) {
                    const allProductsAvailable = associatedVariants.some(variants => {
                        return variants.reduce((acc, curr) => acc && curr.available, true);
                    });
                    if (!allProductsAvailable) {
                        el.classList.add("product-option--unavailable"); // make unavailable for now until we determine how to handle out of stock bundles
                    }
                }
                else {
                    el.classList.add("product-option--unavailable");
                }
            }
            else {
                const effectiveSelections = getEffectiveSelections(selectedOptions, this.selectedProductIdStore.get());
                const associatedVariants = getAssociatedVariants(optionName, optionValue, optionProductId, effectiveSelections, this.selectedProductIdStore.get());
                if (associatedVariants.length) {
                    // don't update out-of-stock status display for products in a store collection as the site only takes into account online inventory for now
                    if (this.getAttribute('under_store_collection') === 'true') {
                        return;
                    }
                    const hasAvailableVariant = associatedVariants.some(av => av.available);
                    if (!hasAvailableVariant) {
                        el.classList.add("product-option--out-of-stock");
                    }
                    else {
                        const hasExpeditedShippingAllowedVariant = associatedVariants.some(av => !av.standardShippingOnly); // if any variant allows expedited shipping, show the expedited shipping allowed icon
                        if (hasExpeditedShippingAllowedVariant) {
                            el.classList.add("product-option--expedited-shipping-allowed");
                        }
                    }
                }
                else {
                    el.classList.add("product-option--unavailable");
                }
            }
        });
    }
    updateExpeditedToggleDisplay(filter) {
        const switchInput = this.querySelector('.js-expedited-options-switch');
        if (!switchInput) {
            return;
        }
        const isExpedited = filter === EXPEDITED_OPTIONS_FILTER.EXPEDITED;
        switchInput.checked = isExpedited;
        switchInput.setAttribute('aria-checked', `${isExpedited}`);
    }
    shouldShowExpeditedOptionsToggle(productId) {
        return shouldShowExpeditedOptionsFilter(productId);
    }
    applyExpeditedOptionsFilter(filter, selectedOptions, productId) {
        const isExpeditedFilterActive = filter === EXPEDITED_OPTIONS_FILTER.EXPEDITED;
        this.querySelectorAll('.js-product-option:not(.product-option__value-button--custom)').forEach((el) => {
            const { optionName, optionValue, productId: optionProductId } = el.dataset;
            const shouldHide = isExpeditedFilterActive && !hasExpeditedEligibleVariant(optionName, optionValue, optionProductId ? +optionProductId : null, selectedOptions, productId);
            el.classList.toggle('product-option--expedited-filtered', shouldHide);
        });
        this.querySelectorAll('.product-option__container').forEach((container) => {
            if (!isExpeditedFilterActive) {
                container.classList.remove('product-option__container--expedited-filtered-empty');
                return;
            }
            const hasVisibleOption = Array.from(container.querySelectorAll('.js-product-option:not(.product-option__value-button--custom)')).some((el) => {
                return !el.classList.contains('product-option--expedited-filtered') && !el.classList.contains('product-option--unavailable');
            });
            container.classList.toggle('product-option__container--expedited-filtered-empty', !hasVisibleOption);
        });
    }
    clearExpeditedFilteredSelections(filter, selectedOptions, productId) {
        if (filter !== EXPEDITED_OPTIONS_FILTER.EXPEDITED) {
            return selectedOptions;
        }
        const singleValueOptions = getSingleValueOptionsForProduct(productId);
        let hasClearedSelection = false;
        const clearedSelections = { ...selectedOptions };
        Object.entries(selectedOptions).forEach(([optionName, optionValue]) => {
            if (!optionValue || optionName === COLOR_OPTION_NAME || singleValueOptions.has(optionName)) {
                return;
            }
            const selectedOptionEl = this.querySelector(`.js-product-option[data-option-name="${optionName}"][data-option-value="${optionValue}"]:not(.product-option__value-button--custom)`);
            const optionProductId = selectedOptionEl?.dataset.productId ? +selectedOptionEl.dataset.productId : null;
            if (!hasExpeditedEligibleVariant(optionName, optionValue, optionProductId, getEffectiveSelections(selectedOptions, productId), productId)) {
                clearedSelections[optionName] = undefined;
                hasClearedSelection = true;
            }
        });
        return hasClearedSelection ? clearedSelections : selectedOptions;
    }
}
if (!window.customElements.get("product-main")) {
    customElements.define("product-main", ProductMain);
}
function buildUrlParamsFromSelectedOptions(options) {
    return Object.entries(options).filter(e => {
        const [key, val] = e;
        return key !== COLOR_OPTION_NAME && !!val;
    }).reduce((acc, curr) => {
        const [key, val] = curr;
        return `${acc}${acc ? "&" : ''}${key}=${val}`;
    }, '');
}
function getInitialSelectionsFromSearchParams(str) {
    const urlParams = new URLSearchParams(str);
    const values = {};
    Object.keys(window.initialDefaultSelections).forEach((prop) => {
        if (urlParams.has(prop)) {
            values[prop] = urlParams.get(prop);
        }
    });
    return values;
}
function allVariants() {
    return window.variantsArray.filter(shownVariant);
}
function allBundledVariants() {
    return Object.values(window.bundleVariantGroups).flat().filter(shownVariant);
}
function getCtaText(ctaType) {
    return window.productUi.ctas[ctaType];
}
function getCurrentProductColorHandle(productId) {
    const variant = allVariants().find((v) => v.productId === productId);
    return variant?.optionsMap[COLOR_OPTION_NAME];
}
function getEffectiveSelections(selectedOptions, productId) {
    const effectiveSelections = { ...selectedOptions };
    if (!effectiveSelections[COLOR_OPTION_NAME]) {
        const currentProductColor = getCurrentProductColorHandle(productId);
        if (currentProductColor) {
            effectiveSelections[COLOR_OPTION_NAME] = currentProductColor;
        }
    }
    return effectiveSelections;
}
function getProductVariantsFromOptions(selectedOptions, currentProductId) {
    return allVariants().filter(v => v.productId === currentProductId).filter(v => {
        return Object.entries(selectedOptions).filter(entry => !!entry[1]).reduce((acc, curr) => {
            const [key, val] = curr;
            return acc && v.optionsMap[key] === val;
        }, true);
    });
}
function isDeselecting(target, currentVal, selectedVal) {
    return !target.dataset.productUrl && currentVal === selectedVal;
}
function getSingleValueOptionsForProduct(productId) {
    const optionValuesByName = {};
    allVariants()
        .filter((v) => v.productId === productId)
        .forEach((variant) => {
        Object.entries(variant.optionsMap).forEach(([optionName, optionValue]) => {
            if (!optionValue) {
                return;
            }
            if (!optionValuesByName[optionName]) {
                optionValuesByName[optionName] = new Set();
            }
            optionValuesByName[optionName].add(optionValue);
        });
    });
    return new Set(Object.entries(optionValuesByName)
        .filter(([, values]) => values.size <= 1)
        .map(([optionName]) => optionName));
}
function shouldShowExpeditedOptionsFilter(productId) {
    const productVariants = allVariants().filter((v) => v.productId === productId);
    if (!productVariants.length) {
        return false;
    }
    const hasExpeditedEligibleVariant = productVariants.some((variant) => !variant.standardShippingOnly);
    const hasStandardShippingOnlyVariant = productVariants.some((variant) => variant.standardShippingOnly);
    return hasExpeditedEligibleVariant && hasStandardShippingOnlyVariant;
}
function hasExpeditedEligibleVariantsForProduct(productId) {
    return allVariants()
        .filter((v) => v.productId === productId)
        .some((variant) => !variant.standardShippingOnly);
}
function hasExpeditedEligibleVariant(optionName, optionValue, optionProductId, selectedOptions, productId) {
    return getAssociatedVariants(optionName, optionValue, optionProductId, selectedOptions, productId)
        .some((variant) => !variant.standardShippingOnly && variant.available);
}
function getAssociatedVariants(optionName, optionValue, optionProductId, selectedOptions, productId) {
    let associatedVariants = allVariants().filter(v => matchesCurrentAndSelectedOptions(v, optionName, optionValue, selectedOptions));
    if (optionName !== COLOR_OPTION_NAME) {
        associatedVariants = associatedVariants.filter(v => v.productId === productId);
    }
    else {
        associatedVariants = associatedVariants.filter(v => v.productId === optionProductId);
    }
    return associatedVariants;
}
function getAssociatedBundleVariants(optionName, optionValue, selectedOptions) {
    const numProducts = Object.keys(window.bundleVariantGroups).length;
    const groupingFunc = (v) => {
        return Object.entries(v.optionsMap)
            .filter(e => e[0] !== COLOR_OPTION_NAME)
            .map(e => e[1])
            .reduce((acc, curr) => acc + curr, '');
    };
    const groups = groupBy(allBundledVariants(), groupingFunc);
    return Object.values(groups)
        .filter(variants => variants.length && variants.length === numProducts)
        .filter(variants => matchesCurrentAndSelectedOptions(variants[0], optionName, optionValue, selectedOptions));
}
function generateErrorFromProductOptions(options) {
    const missingOptions = Object.entries(options).filter(e => !e[1]);
    let errorMessage = 'Please select all options.';
    if (missingOptions.length && missingOptions.length <= 2) {
        const optionText = missingOptions.reduce((acc, curr) => {
            const [key] = curr;
            const msg = `${acc ? ' and ' : ''}${key.replace("-", " ")}`;
            return acc + msg;
        }, '');
        errorMessage = `Please select ${optionText.indexOf('and') > -1 ? 'both' : ['a', 'e', 'i', 'o', 'u'].indexOf(optionText[0]) > -1 ? 'an' : 'a'} ${optionText}.`;
    }
    return errorMessage;
}
function removeErrorMessage() {
    const errorEl = document.querySelector('.product__error-message');
    if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.add('hidden');
    }
}
function showErrorMessage(err) {
    const errorEl = document.querySelector('.product__error-message');
    if (errorEl) {
        errorEl.textContent = err;
        errorEl.classList.remove('hidden');
    }
}
export const _forTesting = {
    getAssociatedVariants,
    generateErrorFromProductOptions,
    hasExpeditedEligibleVariant,
    hasExpeditedEligibleVariantsForProduct,
    shouldShowExpeditedOptionsFilter,
    getSingleValueOptionsForProduct,
    getEffectiveSelections,
    getCurrentProductColorHandle,
};
function generateGiftCardId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
